import { atom } from 'recoil';

export const isNewDropoffModalOpenAtom = atom<boolean>({
  key: 'isNewDropoffModalOpenState',
  default: false,
});
